<template>
  <v-content>
    <v-container @keyup.enter='login' class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" :md="columnnum">
          <v-card class="elevation-12" v-if="!isAuthenticated">
            <v-toolbar color="primary" dark flat>
              <v-container>
                <v-toolbar-title>{{ title  }} </v-toolbar-title>
              </v-container>
              <v-spacer />
              <v-toolbar-items>
                <v-select
                  @change="changedLanguage"
                  :value="selectedLanguage"
                  :items="languages"
                  item-value="lang_code"
                  :item-text="item =>`${this.$t(item.lang_name)}`"
                  :label="'Language' | translate "
                  outlined
                  dense
                  class="pt-3"
                  style="width:140px;"
                ></v-select>
              </v-toolbar-items>
            </v-toolbar>
            <v-container>
              <v-card-text>
                  <template v-if="typeof errors === 'object' && Object.keys(errors).length >0">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">                        
                      <v-alert
                      dense
                      v-for="(v, k) in errors"
                      :key="k"
                      outlined
                      type="error"
                      >{{ k }} {{ v }}</v-alert>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-else-if="errors.length >0 ? true: false">
                    <v-row>
                      <v-col cols="12" sm="12" md="12"> 

                          <v-alert
                            dense
                            outlined
                            
                            type="error"
                          >{{ errors | translate }}</v-alert>

                      </v-col>
                    </v-row>
                  </template >
                <v-form v-model="valid" ref="form">
                  <v-text-field
                    v-model="username"
                    :label=" 'Username' | translate"
                    name="username"
                    prepend-icon="person"
                    type="text"
                    :rules="usernameRules">
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>  
                    </v-text-field>
                  <v-text-field
                    v-model="password"
                    :label=" 'Password' | translate"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    :rules="passwordRules"
                  >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>                    
                  </v-text-field>
                  <v-col class="text-right">
                    <v-btn class="mr-n5 primary--text" text @click="forgotPassword">{{ 'Forgot password' | translate }}</v-btn>
                  </v-col>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" v-if='allowregistration.allow_registration' text @click="register">{{ 'Register' | translate }}</v-btn>
                <v-spacer v-if="this.lms_login"/>
                <v-btn v-if="this.microsoft_login" outlined color="#D53A00" @click="microsoftlogin">{{ 'Login with Office' | translate }}
                  <v-icon
                    right
                  >
                    mdi-microsoft-office
                  </v-icon></v-btn>
                <v-btn v-if="this.lms_login" color="primary" @click="login">{{ 'Login' | translate }}</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-overlay :value="loadingdata==true && isAuthenticated == true">
          <v-layout row justify-center v-if="loadingdata==true && isAuthenticated == true">
            <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
              <v-container fill-height>
                <v-layout row justify-center align-center>
                  <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </v-layout>
              </v-container>
            </v-dialog>
          </v-layout>
        </v-overlay>

    </v-container>
    <div class="text-center">
        <v-dialog v-model="twofamodal" persistent max-width="750">
          <v-card  class="d-flex flex-column" min-height="400">
            <v-form v-model="valid" ref="form2fa">
       
            <v-card-title class="text-h5 primary white--text">{{ "2-Step Verification"| translate }}</v-card-title>
              <v-card-subtitle class="pa-10 mt-8 subtitle-1">
                  
                  <template v-if="typeof errors === 'object' && Object.keys(errors).length >0">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">                        
                      <v-alert
                      dense
                      v-for="(v, k) in errors"
                      :key="k"
                      outlined
                      type="error"
                      >{{ k }} {{ v }}</v-alert>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-else-if="errors.length >0 ? true: false">
                    <v-row>
                      <v-col cols="12" sm="12" md="12"> 
                          <v-alert
                            dense
                            outlined
                            type="error"
                          >{{ errors | translate}}</v-alert>
                      </v-col>
                    </v-row>
                  </template >

                {{ "Enter the 6 digit code that we sent to your email address to finish setting up two-factor authentication."| translate }}
                  <v-text-field
                      v-model="twofa_code"
                      :label=" 'Token' | translate"
                      name="twofa_code"
                      prepend-icon="lock"
                      type="text"
                      :rules="twofaRules"
                  >
                      <template #message="{ message }">
                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                      </template>  
                  </v-text-field>
              </v-card-subtitle>

              </v-form>

                <v-spacer></v-spacer>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="closetwofaModal()">{{ 'Back' | translate }}</v-btn>
                  <v-btn :disabled="cansubmit" color="primary" @click="loginnormal">{{ 'Login' | translate }}</v-btn>
                </v-card-actions>

          </v-card>
        </v-dialog>
    </div>


  </v-content>
</template>

<script>
import Vue from "vue";
import { LOGOUT, GETTOKEN, LOGIN, MICROSOFTLOGIN, FETCH_VIDEO_DATA, PAGES_RESET_STATE,FETCH_STRIPE_SECRET_KEY, FETCH_STRIPE_ALL_CARDS, STRIPE_RESET_STATE,FETCH_USER_REGISTRATION_STATUS, FETCH_LANGUAGES, FETCH_PAGES, FETCH_ADDITIONAL_PAGES, FETCH_ADDITIONAL_PAGES_ON_SIDE_MENU, FETCH_INBOX_MESSAGES, RESET_STATE } from "@/store/actions.type"
import { PURGE_AUTH,SET_LOADING, SET_LOGGED_IN,SET_CUR_LANGUAGE } from "@/store/mutations.type"
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import store from "@/store"
export default {
  name: "Login",
  async beforeRouteEnter(to, from, next) {
    await store.commit(SET_LOGGED_IN, false)
    await store.dispatch(STRIPE_RESET_STATE)
    await store.commit(PURGE_AUTH)
    await store.dispatch(PAGES_RESET_STATE)
    await store.dispatch(RESET_STATE)
    await store.dispatch(LOGOUT)
    await store.dispatch(FETCH_USER_REGISTRATION_STATUS, 'user').then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false);

      }
    });

    return next();
  },  
  data() {
    return {
      valid: false,
      username: "",
      password: "",
      title: '',
      lms_login:false,
      microsoft_login:false,
      twofa_code: "",
      twofamodal:false,
      cansubmit:false,
    };
  },
  watch: {
    twofa_code(newValue){
      this.cansubmit = false;
      if(newValue.length==6){
        this.cansubmit = true;
        this.loginnormal();
      }
    },
  }, 
  methods: {
    closetwofaModal(){
      this.twofamodal = false;
      this.$store.commit(SET_LOADING, false)
    },
    async login() {
      if (this.$refs.form.validate()) {
        if(process.env.VUE_APP_ENABLE_TWO_FA_AUTH=='false'){
          this.loginnormal();
          return;
        }
        let username = this.username;
        let password = this.password;
        await this.$store
          .dispatch(GETTOKEN, { username, password })
          .then(async loginresp=> { 
            if(loginresp!= undefined && loginresp.success){
              this.$store.state.auth.autherrors = ''; //Clearing any errors thrown fro the previous screen
              this.twofamodal = true;
            }
            else{
              this.$store.commit(SET_LOADING, false)
            } 
          });
      }
    },
    async loginnormal(){
      let $validatedForm = false;
      if(process.env.VUE_APP_ENABLE_TWO_FA_AUTH=='false'){
        $validatedForm = this.$refs.form.validate();
      }
      else{
        $validatedForm =  this.$refs.form2fa.validate();
      }

      if ($validatedForm) {
        let username = this.username;
        let password = this.password;
        let twofa_code = this.twofa_code;
        await this.$store.dispatch(LOGIN, { username, password,twofa_code }).then(async loginresp=> { 
            if(loginresp !== undefined && loginresp.hasOwnProperty('success') && loginresp.success ==true){
                await this.$store.dispatch(FETCH_LANGUAGES, '').then(async resp =>{
                if(resp.success){

                this.$store.dispatch(FETCH_INBOX_MESSAGES, '?type=inbox&is_read=0').then((resp) => {
                  if (resp.success) {
                    localStorage.setItem("isReadCount", resp.data.length);
                  }
                })
                
                await this.$store.dispatch(FETCH_ADDITIONAL_PAGES,"?replace_content=true");
                await this.$store.dispatch(FETCH_ADDITIONAL_PAGES_ON_SIDE_MENU,"?show_on_side_menu=true&replace_content=true");

                await this.$store
                  .dispatch(FETCH_PAGES, "?lang_ids=" + loginresp.data.user.company.language.lang_id).then(resp => {
                    if (resp.success) {
                        this.$store.dispatch(FETCH_VIDEO_DATA, '').then(resp =>{ 
                          if(resp.success){
                            var date = new Date();
                            let days = days || 365;
                            date.setTime(+ date + (days * 86400000));
                            document.cookie ='company_domain='+location.host+'; domain='+ process.env.VUE_APP_ENV_DOMAIN +'; expires='+date.toGMTString()+'; path=/;'
                            this.$store.commit(SET_LOADING, false)
                            if(loginresp.data.user.roles.length == 1 && loginresp.data.user.roles[0] == 5)
                            this.$router.push("/drafts")
                            else
                            this.$router.push("/dashboard")
                          }
                      })

                    }
                  });
                }
              }) 

              if(store.state.auth.user.company.account_type == "on-demand"){
                  await this.$store.dispatch(FETCH_STRIPE_SECRET_KEY, "setup-intent").then(resp => {
                    if (resp.success) {

                      this.$store.commit(SET_LOADING, false);
                    }
                  }); 
              }

            if (
              store.state.auth.user.card_brand !== null &&
              store.state.auth.user.company.account_type == "on-demand"
            ) {

                await this.$store.dispatch(FETCH_STRIPE_ALL_CARDS, "list-card").then(resp => {
                  if (resp.success) {
                    this.$store.commit(SET_LOADING, false);
                  }
                });
            }


            }
        });
      }
    },
     async microsoftlogin() {
        await this.$store
          .dispatch(MICROSOFTLOGIN)
          .then(async loginresp=> { 
            if(!loginresp.success){
              this.$store.commit(SET_LOADING, false)
            }
          });
    },
    async selLanguage(language) {
      await this.$store.commit(SET_CUR_LANGUAGE, language);
    },
    forgotPassword(){
      this.$router.push("/forgot-password")
    },
    register(){
      this.$router.push("/register")
    },    
    async changedLanguage(value) {
      Vue.i18n.set(value);
      let selectedLanguage = this.languages.find(x => value == x.lang_code);
      this.selLanguage(selectedLanguage)
    },
    activateLoginOptions(){
        if (typeof this.loginoptions !== 'undefined' && this.loginoptions.length > 0) {
          if(this.loginoptions.includes("lms_login")){
            this.lms_login=true
          }
          if(this.loginoptions.includes("microsoft_login")){
            this.microsoft_login=true
          }
        }
        else{
          this.lms_login=true;
        }
      },
  },
  computed: {
    ...mapState({
      errors: state => state.auth.autherrors,
      }),
      languages(){
        let data = [{"lang_id":1,"lang_name": this.$t("English"),"lang_code":"en"},{"lang_id":2,"lang_name": this.$t("German"),"lang_code":"de"}]
        return data
      },
      usernameRules(){
        return [v => !!v || 'Username is required']
      },
      passwordRules(){
        return [v => !!v || 'Password is required']
      },
      twofaRules(){
        return [v => !!v || 'Token is required']
      },
      columnnum(){
        return (this.microsoft_login?'6':'4')
      },
      selectedLanguage(){
        return this.curLanguage !== null ? this.curLanguage.lang_code : this.allowregistration.lang_code
      },
    ...mapGetters([
      "allowregistration",'curLanguage','loadingdata','loginoptions','additionalpages','additionalpagessidemenu'
    ]),   
    isAuthenticated : function(){ return this.$store.getters.isAuthenticated}  
  },
  created(){
    this.changedLanguage(this.selectedLanguage)
    switch (process.env.VUE_APP_TITLE){
      case "Eve Hub":
        this.title= "Evaluation Experts Hub"
        break;
      case "Learn Ndt":
        this.title= "Learn Ndt"
        break;
      default:
        this.title= "Lean Ndt"
    }
  
    if(this.isAuthenticated){
      this.$router.push("/dashboard")
    }    
    this.activateLoginOptions()
  }
};
</script>
